import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [adminToken, setAdminToken] = useState(() => sessionStorage.getItem("cz_admin_token"));
  const [voucherSession, setVoucherSession] = useState(() => {
    const stored = sessionStorage.getItem("cz_voucher");
    return stored ? JSON.parse(stored) : null;
  });

  const loginAdmin = useCallback((token) => {
    sessionStorage.setItem("cz_admin_token", token);
    setAdminToken(token);
  }, []);

  const logoutAdmin = useCallback(() => {
    sessionStorage.removeItem("cz_admin_token");
    setAdminToken(null);
  }, []);

  const loginVoucher = useCallback((data) => {
    const session = { token: data.token, voucherId: data.voucher_id, alias: data.alias };
    sessionStorage.setItem("cz_voucher", JSON.stringify(session));
    setVoucherSession(session);
  }, []);

  const logoutVoucher = useCallback(() => {
    sessionStorage.removeItem("cz_voucher");
    setVoucherSession(null);
  }, []);

  // Clear voucher session on tab close (handled by sessionStorage automatically)

  return (
    <AuthContext.Provider
      value={{ adminToken, voucherSession, loginAdmin, logoutAdmin, loginVoucher, logoutVoucher }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function RequireVoucher({ children }) {
  const { voucherSession } = useAuth();
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (!voucherSession) setRedirect(true);
  }, [voucherSession]);

  if (redirect && !voucherSession) {
    window.location.href = "/";
    return null;
  }
  return children;
}

export function RequireAdmin({ children }) {
  const { adminToken } = useAuth();
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (!adminToken) setRedirect(true);
  }, [adminToken]);

  if (redirect && !adminToken) {
    window.location.href = "/admin";
    return null;
  }
  return children;
}
